import { axios } from '@/utils/request'
import qs from 'qs'

let moduleName = 'footprint'


export function insert(parameter) {
  console.log('data:', parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'post',
    data: parameter
  })
}

export function selectAll(parameter) {
  console.log('params:', parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function deleteObj(ids){
  console.log("ids",ids)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'delete',
    params:ids,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function getWaitRelease(year) {
  return axios({
    url: `/ws/${moduleName}/getWaitRelease/${year}`,
    method: 'get'
  })
}


export function showFootprint() {
  return axios({
    url: `/ws/${moduleName}/showFootprint`,
    method: 'get'
  })
}


export function insertShow(id) {
  return axios({
    url: `/ws/${moduleName}/insertShow/${id}`,
    method: 'post'
  })
}


export default {
  delete:deleteObj,
  save:insert,
  selectAll,
  getWaitRelease,
  showFootprint,
  insertShow
}